import { getConfig } from 'EnvConfig'

const requestThemeData = async (
  orgId: string,
  designId: string
): Promise<unknown> => {
  const response = await fetch(
    `${
      getConfig().DESIGN_BUILDER_API_URL
    }/designs/${designId}/parse?theme=NEW&orgId=${orgId}`
  )

  if (!response.ok) {
    throw new Error(`Theme request failed (${response.status})`)
  }

  return response.json()
}

let primed: { key: string; promise: Promise<unknown> } | undefined

const toKey = (orgId: string, designId: string) => `${orgId}/${designId}`

export const primeThemeData = (orgId: string, designId: string) => {
  const promise = requestThemeData(orgId, designId)

  // Nobody may consume it, and a rejection there must not surface as unhandled.
  promise.catch(() => undefined)
  primed = { key: toKey(orgId, designId), promise }
}

export const fetchThemeData = (
  orgId: string,
  designId: string
): Promise<unknown> => {
  const handoff = primed

  // Consumed once, so later design changes and remounts hit the network.
  primed = undefined

  if (handoff?.key !== toKey(orgId, designId)) {
    return requestThemeData(orgId, designId)
  }

  return handoff.promise.catch(() => requestThemeData(orgId, designId))
}
